/**
 * @generated SignedSource<<349f19d58d06ea6bda82584d93fe5cdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MetaCompareEnum = "BETWEEN" | "EQUAL_TO" | "EXISTS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUAL_TO" | "IN" | "LESS_THAN" | "LESS_THAN_OR_EQUAL_TO" | "LIKE" | "NOT_BETWEEN" | "NOT_EQUAL_TO" | "NOT_EXISTS" | "NOT_IN" | "NOT_LIKE";
export type MetaTypeEnum = "BINARY" | "CHAR" | "DATE" | "DATETIME" | "DECIMAL" | "NUMERIC" | "SIGNED" | "TIME" | "UNSIGNED";
export type MimeTypeEnum = "APPLICATION_JAVA" | "APPLICATION_MSWORD" | "APPLICATION_OCTET_STREAM" | "APPLICATION_ONENOTE" | "APPLICATION_OXPS" | "APPLICATION_PDF" | "APPLICATION_RAR" | "APPLICATION_RTF" | "APPLICATION_TTAF_XML" | "APPLICATION_VND_APPLE_KEYNOTE" | "APPLICATION_VND_APPLE_NUMBERS" | "APPLICATION_VND_APPLE_PAGES" | "APPLICATION_VND_MS_ACCESS" | "APPLICATION_VND_MS_EXCEL" | "APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12" | "APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12" | "APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12" | "APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT" | "APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12" | "APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12" | "APPLICATION_VND_MS_PROJECT" | "APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12" | "APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12" | "APPLICATION_VND_MS_WRITE" | "APPLICATION_VND_MS_XPSDOCUMENT" | "APPLICATION_VND_OASIS_OPENDOCUMENT_CHART" | "APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE" | "APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA" | "APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS" | "APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION" | "APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET" | "APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT" | "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE" | "APPLICATION_WORDPERFECT" | "APPLICATION_X_7Z_COMPRESSED" | "APPLICATION_X_GZIP" | "APPLICATION_X_TAR" | "APPLICATION_ZIP" | "AUDIO_AAC" | "AUDIO_FLAC" | "AUDIO_MIDI" | "AUDIO_MPEG" | "AUDIO_OGG" | "AUDIO_WAV" | "AUDIO_X_MATROSKA" | "AUDIO_X_MS_WAX" | "AUDIO_X_MS_WMA" | "AUDIO_X_REALAUDIO" | "FONT_OTF" | "FONT_TTF" | "FONT_WOFF" | "FONT_WOFF2" | "IMAGE_AVIF" | "IMAGE_BMP" | "IMAGE_GIF" | "IMAGE_HEIC" | "IMAGE_HEIC_SEQUENCE" | "IMAGE_HEIF" | "IMAGE_HEIF_SEQUENCE" | "IMAGE_JPEG" | "IMAGE_PNG" | "IMAGE_TIFF" | "IMAGE_WEBP" | "IMAGE_X_ICON" | "TEXT_CALENDAR" | "TEXT_CSS" | "TEXT_CSV" | "TEXT_PLAIN" | "TEXT_RICHTEXT" | "TEXT_TAB_SEPARATED_VALUES" | "TEXT_VTT" | "VIDEO_3GPP" | "VIDEO_3GPP2" | "VIDEO_AVI" | "VIDEO_DIVX" | "VIDEO_MP4" | "VIDEO_MPEG" | "VIDEO_OGG" | "VIDEO_QUICKTIME" | "VIDEO_WEBM" | "VIDEO_X_FLV" | "VIDEO_X_MATROSKA" | "VIDEO_X_MS_ASF" | "VIDEO_X_MS_WM" | "VIDEO_X_MS_WMV" | "VIDEO_X_MS_WMX";
export type OrderEnum = "ASC" | "DESC";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type PostObjectsConnectionOrderbyEnum = "AUTHOR" | "COMMENT_COUNT" | "DATE" | "IN" | "MENU_ORDER" | "MODIFIED" | "NAME_IN" | "PARENT" | "SLUG" | "TITLE";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FAILED" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "IN_PROGRESS" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type RelationEnum = "AND" | "OR";
export type TaxQueryField = "ID" | "NAME" | "SLUG" | "TAXONOMY_ID";
export type TaxQueryOperator = "AND" | "EXISTS" | "IN" | "NOT_EXISTS" | "NOT_IN";
export type TaxonomyEnum = "CATEGORY" | "GRAPHQLDOCUMENTGROUP" | "POSTFORMAT" | "TAG";
export type ZnglistTemplateTypeEnum = "CLASSIC" | "PENDING" | "PERSONAL";
export type ZnglistUserTypeEnum = "ADMIN" | "USER";
export type RootQueryToZnglistConnectionWhereArgs = {
  author?: number | null | undefined;
  authorId?: string | null | undefined;
  authorIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  authorName?: string | null | undefined;
  authorNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  dateQuery?: DateQueryInput | null | undefined;
  hasPassword?: boolean | null | undefined;
  id?: number | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  metaQuery?: MetaQuery | null | undefined;
  mimeType?: MimeTypeEnum | null | undefined;
  name?: string | null | undefined;
  nameIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  notIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  orderby?: ReadonlyArray<PostObjectsConnectionOrderbyInput | null | undefined> | null | undefined;
  parent?: string | null | undefined;
  parentIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  parentNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  password?: string | null | undefined;
  search?: string | null | undefined;
  stati?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  status?: PostStatusEnum | null | undefined;
  taxQuery?: TaxQuery | null | undefined;
  templateType?: ReadonlyArray<ZnglistTemplateTypeEnum | null | undefined> | null | undefined;
  title?: string | null | undefined;
  userType?: ZnglistUserTypeEnum | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type MetaQuery = {
  metaArray?: ReadonlyArray<MetaArray | null | undefined> | null | undefined;
  relation?: RelationEnum | null | undefined;
};
export type MetaArray = {
  compare?: MetaCompareEnum | null | undefined;
  key?: string | null | undefined;
  type?: MetaTypeEnum | null | undefined;
  value?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type PostObjectsConnectionOrderbyInput = {
  field: PostObjectsConnectionOrderbyEnum;
  order: OrderEnum;
};
export type TaxQuery = {
  relation?: RelationEnum | null | undefined;
  taxArray?: ReadonlyArray<TaxArray | null | undefined> | null | undefined;
};
export type TaxArray = {
  field?: TaxQueryField | null | undefined;
  includeChildren?: boolean | null | undefined;
  operator?: TaxQueryOperator | null | undefined;
  taxonomy?: TaxonomyEnum | null | undefined;
  terms?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type Znglist_List_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToZnglistConnectionWhereArgs | null | undefined;
};
export type Znglist_List_Query$data = {
  readonly znglists: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly title: string | null | undefined;
    }>;
  } | null | undefined;
};
export type Znglist_List_Query = {
  response: Znglist_List_Query$data;
  variables: Znglist_List_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "where"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "RootQueryToZnglistConnection",
    "kind": "LinkedField",
    "name": "znglists",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Znglist",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Znglist_List_Query",
    "selections": (v3/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "Znglist_List_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "24ea3dca2dcc621dcd77307dc7a7e89e",
    "id": null,
    "metadata": {},
    "name": "Znglist_List_Query",
    "operationKind": "query",
    "text": "query Znglist_List_Query(\n  $first: Int\n  $after: String\n  $where: RootQueryToZnglistConnectionWhereArgs\n) {\n  znglists(first: $first, after: $after, where: $where) {\n    nodes {\n      title\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ffef3a48b09de56c024b5ef6e95650e";

export default node;
